/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimReservationCommunicationMethod } from './ClaimReservationCommunicationMethod';
import {
    ClaimReservationCommunicationMethodFromJSON,
    ClaimReservationCommunicationMethodFromJSONTyped,
    ClaimReservationCommunicationMethodToJSON,
} from './ClaimReservationCommunicationMethod';

/**
 * 
 * @export
 * @interface ResendClaimFormNotificationRequest
 */
export interface ResendClaimFormNotificationRequest {
    /**
     * 
     * @type {ClaimReservationCommunicationMethod}
     * @memberof ResendClaimFormNotificationRequest
     */
    method: ClaimReservationCommunicationMethod;
}



/**
 * Check if a given object implements the ResendClaimFormNotificationRequest interface.
 */
export function instanceOfResendClaimFormNotificationRequest(value: object): value is ResendClaimFormNotificationRequest {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function ResendClaimFormNotificationRequestFromJSON(json: any): ResendClaimFormNotificationRequest {
    return ResendClaimFormNotificationRequestFromJSONTyped(json, false);
}

export function ResendClaimFormNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendClaimFormNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'method': ClaimReservationCommunicationMethodFromJSON(json['method']),
    };
}

export function ResendClaimFormNotificationRequestToJSON(value?: ResendClaimFormNotificationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'method': ClaimReservationCommunicationMethodToJSON(value['method']),
    };
}

